import React, { PropsWithChildren } from 'react';
import { EnvironmentFactory } from 'StorytellerEnvironment';
import { inPrintMode } from 'util/in-print-mode';
import { DerivedReportContext, useDerivedReport } from './DerivedReportContext';
import { StorySaveDropdown } from './StorySaveDropdown/StorySaveDropdown';
import { StoryBreadcrumbs } from './StoryBreadcrumbs';
import { ForgeIcon } from '@tylertech/forge-react';
import { useSelector } from 'react-redux';
import { selectHasStoryChanged } from 'store/reducers/StoryChangesReducer';

/**
 * Wrapper that provides the view to the View story bar.
 */
function ViewStoryBarWrapper({ children }: PropsWithChildren<{}>) {
  const Environment = EnvironmentFactory();
  const view = Environment.CORE_VIEW;
  if (!view || !Environment.RELATED_STORIES || inPrintMode()) {
    return null;
  }

  const value = {
    currentStory: view,
    defaultStory: Environment.RELATED_STORIES.defaultStory,
  };

  return <DerivedReportContext.Provider value={value}>{children}</DerivedReportContext.Provider>;
}

/**
 * The actual view story bar, which can _use_ `useDerivedReport` now.
 */
function ViewStoryBarCore() {
  const { canCreate, canUpdate } = useDerivedReport();
  const hasStoryChanges = useSelector(selectHasStoryChanged);
  const showSaveButton = (canCreate || canUpdate) && hasStoryChanges;

  return (
    <div data-testid="view-story-bar" id="view-story-bar">
      <StoryBreadcrumbs />
      {showSaveButton && (
        <>
          <ForgeIcon className="breadcrumb-chev" name="chevron_right" />
          <StorySaveDropdown />
        </>
      )}
    </div>
  );
}

export function ViewStoryBar() {
  return (
    <ViewStoryBarWrapper>
      <ViewStoryBarCore />
    </ViewStoryBarWrapper>
  );
}
